import { IFundHeader } from '../interfaces';

export class InvalidFundError extends Error {
  constructor(message: string, private readonly fund: IFundHeader) {
    super(message);
    this.name = 'InvalidFundError';
  }

  getFund() {
    return this.fund;
  }
}
